/* tslint:disable */
/* eslint-disable */
/**
 * cro-fiona-users
 * Fiona User Service
 *
 * The version of the OpenAPI document: 0.1.57
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AvailableUrls,
    Consent,
    ConsentReq,
    GrantProperties,
    UserIdentityProvider,
    UserRequest,
    UserUpgrade,
    UserWithRelations,
    UserWithoutId,
} from '../models';

export interface UserControllerAddUserConsentsRequest {
    consentReq?: Array<ConsentReq>;
}

export interface UserControllerCreateRequest {
    userRequest?: UserRequest;
}

export interface UserControllerEditUserRequest {
    id: string;
    userWithoutId?: UserWithoutId;
}

export interface UserControllerEditUserSetnxRequest {
    id: string;
    userWithoutId?: UserWithoutId;
}

export interface UserControllerGetUserByIdRequest {
    id: string;
}

export interface UserControllerGetUserConsentRequest {
    id: string;
    type: UserControllerGetUserConsentTypeEnum;
}

export interface UserControllerUpdateUserIdentityProviderRequest {
    id: string;
    userIdentityProvider?: UserIdentityProvider;
}

export interface UserControllerUpgradeRequest {
    userUpgrade?: UserUpgrade;
}

/**
 * UserControllerApi - interface
 * 
 * @export
 * @interface UserControllerApiInterface
 */
export interface UserControllerApiInterface {
    /**
     * 
     * @param {Array<ConsentReq>} [consentReq] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerAddUserConsentsRaw(requestParameters: UserControllerAddUserConsentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Consent>>>;

    /**
     */
    userControllerAddUserConsents(requestParameters: UserControllerAddUserConsentsRequest, initOverrides?: RequestInit): Promise<Array<Consent>>;

    /**
     * 
     * @param {UserRequest} [userRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerCreateRaw(requestParameters: UserControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AvailableUrls>>;

    /**
     */
    userControllerCreate(requestParameters: UserControllerCreateRequest, initOverrides?: RequestInit): Promise<AvailableUrls>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerDisableRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>>;

    /**
     */
    userControllerDisable(initOverrides?: RequestInit): Promise<any>;

    /**
     * 
     * @param {string} id 
     * @param {UserWithoutId} [userWithoutId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerEditUserRaw(requestParameters: UserControllerEditUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>>;

    /**
     */
    userControllerEditUser(requestParameters: UserControllerEditUserRequest, initOverrides?: RequestInit): Promise<any>;

    /**
     * 
     * @param {string} id 
     * @param {UserWithoutId} [userWithoutId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerEditUserSetnxRaw(requestParameters: UserControllerEditUserSetnxRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>>;

    /**
     */
    userControllerEditUserSetnx(requestParameters: UserControllerEditUserSetnxRequest, initOverrides?: RequestInit): Promise<any>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerGetAnonymousUserRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GrantProperties>>;

    /**
     */
    userControllerGetAnonymousUser(initOverrides?: RequestInit): Promise<GrantProperties>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerGetUserByIdRaw(requestParameters: UserControllerGetUserByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserWithRelations>>;

    /**
     */
    userControllerGetUserById(requestParameters: UserControllerGetUserByIdRequest, initOverrides?: RequestInit): Promise<UserWithRelations>;

    /**
     * 
     * @param {string} id 
     * @param {'TCPA' | 'FCRA' | 'ESIGN' | 'CSCORE_VIEW' | 'TU_SCORE'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerGetUserConsentRaw(requestParameters: UserControllerGetUserConsentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Consent>>;

    /**
     */
    userControllerGetUserConsent(requestParameters: UserControllerGetUserConsentRequest, initOverrides?: RequestInit): Promise<Consent>;

    /**
     * 
     * @param {string} id 
     * @param {UserIdentityProvider} [userIdentityProvider] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerUpdateUserIdentityProviderRaw(requestParameters: UserControllerUpdateUserIdentityProviderRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>>;

    /**
     */
    userControllerUpdateUserIdentityProvider(requestParameters: UserControllerUpdateUserIdentityProviderRequest, initOverrides?: RequestInit): Promise<any>;

    /**
     * 
     * @param {UserUpgrade} [userUpgrade] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserControllerApiInterface
     */
    userControllerUpgradeRaw(requestParameters: UserControllerUpgradeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>>;

    /**
     */
    userControllerUpgrade(requestParameters: UserControllerUpgradeRequest, initOverrides?: RequestInit): Promise<any>;

}

/**
 * 
 */
export class UserControllerApi extends runtime.BaseAPI implements UserControllerApiInterface {

    /**
     */
    async userControllerAddUserConsentsRaw(requestParameters: UserControllerAddUserConsentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Consent>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/users/consents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.consentReq,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userControllerAddUserConsents(requestParameters: UserControllerAddUserConsentsRequest = {}, initOverrides?: RequestInit): Promise<Array<Consent>> {
        const response = await this.userControllerAddUserConsentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerCreateRaw(requestParameters: UserControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AvailableUrls>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userControllerCreate(requestParameters: UserControllerCreateRequest = {}, initOverrides?: RequestInit): Promise<AvailableUrls> {
        const response = await this.userControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerDisableRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/users`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async userControllerDisable(initOverrides?: RequestInit): Promise<any> {
        const response = await this.userControllerDisableRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerEditUserRaw(requestParameters: UserControllerEditUserRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userControllerEditUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userWithoutId,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async userControllerEditUser(requestParameters: UserControllerEditUserRequest, initOverrides?: RequestInit): Promise<any> {
        const response = await this.userControllerEditUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerEditUserSetnxRaw(requestParameters: UserControllerEditUserSetnxRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userControllerEditUserSetnx.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/users/{id}/setnx`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userWithoutId,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async userControllerEditUserSetnx(requestParameters: UserControllerEditUserSetnxRequest, initOverrides?: RequestInit): Promise<any> {
        const response = await this.userControllerEditUserSetnxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetAnonymousUserRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GrantProperties>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/users/anonymous`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userControllerGetAnonymousUser(initOverrides?: RequestInit): Promise<GrantProperties> {
        const response = await this.userControllerGetAnonymousUserRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetUserByIdRaw(requestParameters: UserControllerGetUserByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UserWithRelations>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userControllerGetUserById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userControllerGetUserById(requestParameters: UserControllerGetUserByIdRequest, initOverrides?: RequestInit): Promise<UserWithRelations> {
        const response = await this.userControllerGetUserByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetUserConsentRaw(requestParameters: UserControllerGetUserConsentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Consent>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userControllerGetUserConsent.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling userControllerGetUserConsent.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/users/{id}/consents`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userControllerGetUserConsent(requestParameters: UserControllerGetUserConsentRequest, initOverrides?: RequestInit): Promise<Consent> {
        const response = await this.userControllerGetUserConsentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerUpdateUserIdentityProviderRaw(requestParameters: UserControllerUpdateUserIdentityProviderRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userControllerUpdateUserIdentityProvider.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/users/{id}/identity-provider`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userIdentityProvider,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async userControllerUpdateUserIdentityProvider(requestParameters: UserControllerUpdateUserIdentityProviderRequest, initOverrides?: RequestInit): Promise<any> {
        const response = await this.userControllerUpdateUserIdentityProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerUpgradeRaw(requestParameters: UserControllerUpgradeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/users/upgrade`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userUpgrade,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async userControllerUpgrade(requestParameters: UserControllerUpgradeRequest = {}, initOverrides?: RequestInit): Promise<any> {
        const response = await this.userControllerUpgradeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export type UserControllerGetUserConsentTypeEnum = 'TCPA' |'FCRA' |'ESIGN' |'CSCORE_VIEW' |'TU_SCORE' 
